// extracted by mini-css-extract-plugin
export default {"container":"TipsTricks_container__rPjwU","title":"TipsTricks_title__KkJK+","tips":"TipsTricks_tips__KxrSb","altColor":"TipsTricks_altColor__SEmBo"};